import Vue from 'vue'
import VueRouter from 'vue-router'
import security from './../utils/security'

Vue.use(VueRouter)

import agreementRoutes from './../routes/agreement'
import customerRoutes from './../routes/customer'
import debtorRoutes from './../routes/debtor'
import factoredinvoiceRoutes from './../routes/factoredinvoice'
import userRoutes from './../routes/user'
import reportRoutes from './../routes/report'
import securityRoutes from './../routes/security'
import invoiceRoutes from './../routes/invoice'
import settingsRoutes from './../routes/settings'

const router = new VueRouter({
  mode: 'history',
  routes: [
    ...agreementRoutes,
    ...customerRoutes,
    ...debtorRoutes,
    ...factoredinvoiceRoutes,
    ...userRoutes,
    ...invoiceRoutes,
    ...reportRoutes,
    ...securityRoutes,
    ...settingsRoutes
  ]
})

router.beforeEach((to, from, next) => {

  const routesAllowedWithOutLogin = [
    'Login',
    'NewPassword'
  ]
  if (to.name == null) {
    security.redirectToDefaultOrLastRoute()
  } else if (routesAllowedWithOutLogin.indexOf(to.name) > -1 || security.isUserLogin()) {
    next()
  } else {
    security.setLastRoute(to.path)
    next({name: 'Login'})
  }
})

export default router




// WEBPACK FOOTER //
// ./src/config/router.js